import _ from 'lodash';
import $ from 'jquery';
import View from '../view/view.js';

class Modal extends View {

	constructor (tpl, data, options) {
		super(
			`<div class="modal-overlay"> 
				<div class="modal-container start-top transparent">
					<header>
						<h3><%= data.title || '' %></h3>
						<button class="close-btn">
							<i class="fa fa-2x fa-times" aria-hidden="true"></i>
						</button>
					</header>
					<div class="modal-body">` + 
						tpl + 
			`		</div>
				</div>
			</div>`,
			data,
			options
		);

		this.deferred = $.Deferred();
		
		if (data) {
			this.render(data);
		}

		//TODO: Make this configurable?
		this.maxHeightPercent = '95';
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			closeBtn: '.close-btn',
			modalContainer: '.modal-container',
			modalHeader: '.modal-container header',
			modalBody: '.modal-body'
		});
	}

	render(data) {
		super.render(data);

		this.ui.closeBtn.click(() => this.closeHandler());
		
		this.ui.modalContainer.css({
			'max-height': this.maxHeightPercent + '%'
		});

		//TODO: This allows the modal body to have a vertical scroll. We
		//should try to find a better way of doing this, though. This will
		//be unreliable if you want to add stuff to the header, or even if
		//the header title splits in more than 1 line
		setTimeout(() => {
			this._setBodyMaxHeight();
			$(window).on('resize.modal', () => {
				this._setBodyMaxHeight();
			});
		}, 100);

	}

	_setBodyMaxHeight() {
		this.ui.modalBody.css({
			'max-height': (($(window).height() * (this.maxHeightPercent/100) ) - this.ui.modalHeader.outerHeight()) + 'px'
		});
	}

	open() {
		let $body = $('body');
		$body.addClass('modal-open');
		return this.appendTo($body);
	}

	appendTo($el) {
		super.appendTo($el);
		setTimeout(() => this.ui.modalContainer.removeClass('start-top transparent'), 10);
		return this.deferred;
	}

	closeHandler() {
		this.close();
	}

	close(result) {
		this.ui.modalContainer.addClass('transparent');
		setTimeout(() => {
			super.remove();

			$('body').removeClass('modal-open');
			$(window).off('.modal'); //Remove window listeners
			this.ui.closeBtn.off();
			this.deferred.resolve(result);
		}, 300);
		
	}

}

export default Modal;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_components/modal/modal.js